// extracted by mini-css-extract-plugin
module.exports = {"cursor":"cursor-module--cursor--31foq","circle":"cursor-module--circle--2w8il","circleLarge":"cursor-module--circleLarge--2m_Sm","circleSmall":"cursor-module--circleSmall--3oq6z"};